import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject, throwError } from "rxjs";
import { share, map, catchError, finalize, switchMap, tap } from "rxjs/operators";
import { GridOptions } from "ag-grid-community";
import { IServerSideRequestOptions } from "../data-source.interfaces";
import { GridApi } from "ag-grid-community";

export enum DataLoadingStatus {
  Loading,
  NoRows,
  RowsLoaded
}

@Injectable()
export class BsshDataTableApiService {
  public dataLoadingStatus$: BehaviorSubject<DataLoadingStatus>;
  public onDataChanged: BehaviorSubject<any>;

  public apiOrigin: string = "bssh.illumina.com";

  constructor(private httpClient: HttpClient) {
    this.onDataChanged = new BehaviorSubject([]);
    this.dataLoadingStatus$ = new BehaviorSubject(DataLoadingStatus.Loading);
  }

  get dataChanged(): Observable<any> {
    return this.onDataChanged.asObservable();
  }

  alreadyHitInitialQuery: boolean = false;

  getData(requestOptions: IServerSideRequestOptions = {}, gridOptions: GridOptions | any = {}, api: GridApi) {
    const {
      origin,
      path,
      params,
      preRequestParamsProcessing,
      postSuccessRequestCallback,
      postErrorRequestCallback,
      initialQuery
    } = requestOptions;
    const { startRow, endRow, filterModel, sortModel } = gridOptions;

    const requestData = preRequestParamsProcessing(params, gridOptions, api);

    this.dataLoadingStatus$.next(DataLoadingStatus.Loading);

    if(this.alreadyHitInitialQuery || !initialQuery) {
      return this.httpClient.get(`${origin || this.apiOrigin}/${path}`, { params: requestData }).pipe(
        map((response: any) => {
          const processedData = postSuccessRequestCallback(params, gridOptions, response, api);

          if (!processedData || !processedData.rowData || !processedData.rowData.length) {
            this.dataLoadingStatus$.next(DataLoadingStatus.NoRows);
          } else {
            this.dataLoadingStatus$.next(DataLoadingStatus.RowsLoaded);
          }

          this.onDataChanged.next(processedData);

          return processedData;
        }),
        catchError(err => {
          const error = postErrorRequestCallback(params, gridOptions, err, api);

          return throwError(error);
        }),
        share()
      );
    } else {
      return initialQuery.pipe(
        tap(() => {
          this.alreadyHitInitialQuery = true;
        }),
        switchMap(() => {
          return this.httpClient.get(`${origin || this.apiOrigin}/${path}`, { params: requestData }).pipe(
            map((response: any) => {
              const processedData = postSuccessRequestCallback(params, gridOptions, response, api);

              if (!processedData || !processedData.rowData || !processedData.rowData.length) {
                this.dataLoadingStatus$.next(DataLoadingStatus.NoRows);
              } else {
                this.dataLoadingStatus$.next(DataLoadingStatus.RowsLoaded);
              }

              this.onDataChanged.next(processedData);

              return processedData;
            }),
            catchError(err => {
              const error = postErrorRequestCallback(params, gridOptions, err, api);

              return throwError(error);
            }),
            share()
          );
        })
      )
    }

    
  }
}
